import { Instagram, Mail, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#2C2520] py-20 text-[#FDFBF7]">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal>
          <div className="flex flex-col items-start justify-between gap-12 lg:flex-row lg:items-end">
            <div className="max-w-xl">
              <img src="/logo.jpg" alt="Double Treble Stitches logo" data-testid="footer-logo" className="h-14 w-14 rounded-xl object-cover" />
              <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.1] tracking-tight sm:text-5xl">
                Let&apos;s make something <span className="italic text-[#C88A75]">especially for you.</span>
              </h2>
              <a
                href="#order"
                data-testid="footer-cta-order"
                className="mt-8 inline-block rounded-full bg-[#FDFBF7] px-7 py-3.5 text-sm font-medium text-[#2C2520] transition-colors duration-300 hover:bg-[#C88A75] hover:text-[#FDFBF7]"
              >
                Start a custom order
              </a>
            </div>
            <div className="space-y-4 text-sm text-[#FDFBF7]/75">
              <a href="https://www.instagram.com/doubletreblests" target="_blank" rel="noopener noreferrer" data-testid="footer-link-instagram" className="flex items-center gap-3 transition-colors duration-300 hover:text-[#C88A75]">
                <Instagram className="h-4 w-4" /> @doubletreblests
              </a>
              <a href="mailto:doubletreblests@gmail.com" data-testid="footer-link-email" className="flex items-center gap-3 transition-colors duration-300 hover:text-[#C88A75]">
                <Mail className="h-4 w-4" /> doubletreblests@gmail.com
              </a>
              <p className="flex items-center gap-3" data-testid="footer-location">
                <MapPin className="h-4 w-4" /> Guelph–Waterloo Region, Ontario
              </p>
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#FDFBF7]/45">
                Ships anywhere in Canada &amp; the US
              </p>
            </div>
          </div>
        </Reveal>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-[#FDFBF7]/10 pt-8 sm:flex-row sm:items-center">
          <p className="font-serif text-lg italic text-[#FDFBF7]/60">Double Treble Stitches</p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#FDFBF7]/40">
            Handmade with love by Carol Elisabeth Smith · <span className="text-[#8FD5CB]/70">Original patterns coming soon</span>
          </p>
        </div>
        <p className="mt-8 text-center font-mono text-[10px] uppercase tracking-[0.22em] text-[#FDFBF7]/30">
          Site built by{" "}
          <a
            href="https://thelazycreatorcompany.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-credit-link"
            className="text-[#8FD5CB]/60 transition-colors duration-300 hover:text-[#8FD5CB]"
          >
            The Lazy Creator Company
          </a>
        </p>
      </div>
    </footer>
  );
}
